module.exports = __webpack_public_path__ + "static/img/avatar.60072f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatar.png
// module id = 8fxx
// module chunks = 1